import React from 'react'
import './BottomImage.css'

function BottomImage(props) {
  if (props.url === undefined || props.url === null) {
    return <div className="div-box-img" />
  }

  return (
    <div className="div-box-bottom-img">
      <img className="div-bottom-img" src={props.url} alt="new" />
    </div>
  )
}

export default BottomImage
